export const ExcludeIcon: React.FC = () => {
  return (
    <svg width='19' height='12' viewBox='0 0 19 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M16.4427 6.00065C16.4427 8.76243 14.2038 11.0013 11.4421 11.0013C8.68027 11.0013 6.44141 8.76243 6.44141 6.00065C6.44141 3.23887 8.68027 1 11.4421 1C14.2038 1 16.4427 3.23887 16.4427 6.00065Z'
        fill='white'
      />
      <circle cx='12.0017' cy='5.99976' r='5.49976' stroke='white' />
      <path
        d='M11.4995 5.99976C11.4995 9.03719 9.03719 11.4995 5.99976 11.4995C2.96232 11.4995 0.5 9.03719 0.5 5.99976C0.5 2.96232 2.96232 0.5 5.99976 0.5C7.19782 0.5 8.30507 0.882506 9.20798 1.53214C10.5968 2.53139 11.4995 4.16015 11.4995 5.99976Z'
        fill='white'
        stroke='white'
      />
      <circle cx='12' cy='6' r='5' fill='#9A243A' />
    </svg>
  )
}
